import React from 'react';

import TextField from "@material-ui/core/TextField";

function ValidatedTextField (props) {
  const {
    value,
    readOnly = false,
    disabled = false,
    validator,
    placeholder = ' ',
    startAdornment,
    ...other
  } = props;

  let error = false;
  let helperText = ' ';

  if (!readOnly && !disabled && validator) {
    const validatorMessage = validator (value);
    if (validatorMessage) {
      error = true;
      helperText = validatorMessage;
    }
  }

  return (
    <TextField disabled={disabled}
               placeholder={readOnly ? undefined : placeholder}
               helperText={helperText}
               error={error}
               value={value}
               InputLabelProps={{ shrink: true }}
               InputProps={{
                 readOnly: readOnly,
                 startAdornment: startAdornment
               }}
               variant="outlined"
               {...other} />
  );
}

export default ValidatedTextField;
